export default "__VITE_ASSET__toViUuoe__"